/**
 * Returns true if `input` is a Date object.
 *
 * @example
 * ```ts
 * isDate(new Date()); // true
 * isDate("2024-01-01"); // false
 * ```
 */
const isDate = (input) => {
    return input instanceof Date;
};
export default isDate;
//# sourceMappingURL=isDate.js.map